import { observer } from 'mobx-react';
import * as React from 'react';
import LearningCollectionEditStore from '../../../Edit/Store';
import { ModifiableExperiencesContext } from '../../../Types';
import CustomizeRow from './CustomizeRow';

interface Props {
  context: ModifiableExperiencesContext;
  learningCollectionStore: LearningCollectionEditStore;
}

const DeletedExperiences: React.FC<Props> = ({ context, learningCollectionStore }) =>
  learningCollectionStore.deletedExperienceStores(context).map((experienceStore) => (
    <tr className="border-b" key={experienceStore.experienceResource.payload.id}>
      <CustomizeRow
        context={context}
        experienceResource={experienceStore.experienceResource}
        store={learningCollectionStore}
      />
    </tr>
  ));

export default observer(DeletedExperiences);
